/* eslint-disable react/prop-types */
import axios from 'axios';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
// api
import ApiKey from '../api/ApiKey';
import BaseApi from '../api/BaseApi';
// components
import SmallLoading from './SmallLoading';
import ApplyJobInfoForm from '../forms/applyJobForms/ApplyJobInfoForm';
import ApplyJobSelectForm from '../forms/applyJobForms/ApplyJobSelectForm';
import ApplyJobCheckEmailForm from '../forms/applyJobForms/ApplyJobCheckEmailForm';
import ApplyJobCreateResumeForm from '../forms/applyJobForms/ApplyJobCreateResumeForm';
// helpers
import { logOutIfTokenExpired, resultInfo } from '../helpers';
// mui
import ErrorIcon from '@mui/icons-material/Error';
import CancelIcon from '@mui/icons-material/Cancel';
import { Box, IconButton, Modal } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { GoogleAnalyticsService } from 'core/services/GoogleAnalyticsService';
import {useRootStore} from 'core/hooks/use-root-store';

const ApplyJobModal = ({
  open,
  jobId,
  onClose,
  stepFrom,
  jobTitle,
  onlyResume,
  onlyQuestionnaire,
}) => {
  const rootStore = useRootStore();
  const navigate = useNavigate();
  const { t } = useTranslation('global');
  const tokenKey = Cookies.get('tokenClient');
  const currentLanguage = Cookies.get('selectedLanguage') || 'ukr';

  const [faculties, setFaculties] = useState([]);
  const [directories, setDirectories] = useState({});
  const [profileBody, setProfileBody] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [step, setStep] = useState(stepFrom || 'checkUser');
  const [subscribeAlert, setSubscribeAlert] = useState(true);
  const [checkUserMessage, setCheckUserMessage] = useState('');
  const [emailConfirmCode, setEmailConfirmCode] = useState('');
  const [emailConfirmCodeError, setEmailConfirmCodeError] = useState('');
  const [jobApplyResult, setJobApplyResult] = useState({ result: null, message: '' });
  const [errors, setErrors] = useState({
    contact: '',
    last_name: '',
    first_name: '',
    email_address: '',
  });
  const [checkUserFormData, setCheckUserFormData] = useState({
    contact: '',
    last_name: '',
    first_name: '',
    email_address: '',
  });

  const getUserProfileData = async () => {
    try {
      const response = await axios.post(
        BaseApi + '/candidates/editProfile',
        null,
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
            'Content-Type': 'application/json',
          },
        },
      );

      if (response.data.status === 200) {
        const data = response.data.response;
        const userDetail = data.userdetail;
        setDirectories(data);
        setProfileBody(userDetail);
        setCheckUserFormData({
          last_name: userDetail.last_name,
          first_name: userDetail.first_name,
          contact: userDetail.contact_number,
          email_address: userDetail.email_address,
        });
      } else if (response.data.status === 400) {
        navigate('/');

        Cookies.remove('fname');
        Cookies.remove('user_id');
        Cookies.remove('user_type');
        Cookies.remove('tokenClient');

        resultInfo('warning', response.data.message, t('jobseekerEditProfile.close'));
      } else {
        resultInfo('error', response.data.message, t('jobseekerEditProfile.close'));
      }
    } catch (error) {
      if (
        error.message === 'Network Error' || (error.response && error.response.data.message === 'Token has expired')
      ) {
        navigate('/');

        logOutIfTokenExpired(t('tokenExpired.tokenExpired'), t('tokenExpired.close'));
      }

      console.error(error);
    }
  };

  const handleCheckUser = async e => {
    e.preventDefault();

    const nameFormat = /^[A-Za-zА-Яа-яіІїЇєЄыЫ]+$/;
    const emailFormat = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const contactNumberFormat = /^\+\d{1,3}\d{6,14}$/;

    try {
      const newErrors = {};

      if (checkUserFormData.first_name.trim() === '') {
        newErrors.first_name = t('jobseekerEditProfile.firstNameRequired');
      } else if (!nameFormat.test(checkUserFormData.first_name.trim())) {
        newErrors.first_name = t('jobseekerEditProfile.textFormat');
      } else if (checkUserFormData.first_name.trim().length > 255) {
        newErrors.first_name = t('jobseekerEditProfile.textMaxLength');
      }
      if (checkUserFormData.last_name.trim() === '') {
        newErrors.last_name = t('jobseekerEditProfile.lastNameRequired');
      } else if (!nameFormat.test(checkUserFormData.last_name.trim())) {
        newErrors.last_name = t('jobseekerEditProfile.textFormat');
      } else if (checkUserFormData.last_name.trim().length > 255) {
        newErrors.last_name = t('jobseekerEditProfile.textMaxLength');
      }

      if(checkUserFormData.email_address.trim() === '' &&  checkUserFormData.contact.trim() === "") {
         newErrors.contact = 'Вкажіть телефон або email для зв’язку та підтвердження відгуку'
      }
      if(checkUserFormData.email_address && !emailFormat.test(checkUserFormData.email_address)) {
         newErrors.email_address = t('jobseekerRegister.invalidEmail');
      }
      if(checkUserFormData.contact && !contactNumberFormat.test(checkUserFormData.contact)) {
          newErrors.contact = t('jobseekerEditProfile.contactNumberValidation')
      }
  
      setErrors(newErrors);
     
      if (Object.keys(newErrors).length === 0) {
        setIsSubmitting(true);

        const response = await axios.post(
          BaseApi + '/jobApply/checkUser',
          checkUserFormData,
        );
        if (response.data.status === 200) {
          setCheckUserMessage(response.data.message);
              GoogleAnalyticsService.trackEvent(
        'begin_registration',
         {"SUCCESS": response.data.message})
          setStep('checkEmailCode');
        } else {
          const Toast = Swal.mixin({
            timer: 5000,
            toast: true,
            position: 'top-end',
            timerProgressBar: true,
            showConfirmButton: false,
            didOpen: toast => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: 'error',
            title: t('jobDescription.checkUserError'),
          });
            GoogleAnalyticsService.trackEvent(
        'begin_registration_respond',
         {"ERROR": t('jobDescription.checkUserError')}
      )
        }

        setIsSubmitting(false);
      }else {
        GoogleAnalyticsService.trackEvent(
        'begin_registration',
         {"WARNING": "Validation failed"})
      }
    } catch (error) {
      setIsSubmitting(false);

      const Toast = Swal.mixin({
        timer: 5000,
        toast: true,
        position: 'top-end',
        timerProgressBar: true,
        showConfirmButton: false,
        didOpen: toast => {
          toast.addEventListener('mouseenter', Swal.stopTimer);
          toast.addEventListener('mouseleave', Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: 'error',
        title: t('jobDescription.checkUserError'),
      });

      GoogleAnalyticsService.trackEvent(
        'begin_registration',
         {"ERROR": t('jobDescription.checkUserError')})
    }
  };

  const handleEmailConfirm = async e => {
    e.preventDefault();
 GoogleAnalyticsService.trackEvent(
        'jobseeker_registration',
         {"INFO": "Check email code start"});
    
    try {
      if (emailConfirmCode.trim() === '') {
         GoogleAnalyticsService.trackEvent(
        'jobseeker_registration',
         {"WARNING": t('jobDescription.codeRequired')});
        setEmailConfirmCodeError(t('jobDescription.codeRequired'));
      }

      if (!emailConfirmCodeError) {
        setIsSubmitting(true);

        const response = await axios.post(
          BaseApi + '/jobApply/code',
          {
            code: parseInt(emailConfirmCode),
            email_address: checkUserFormData.email_address,
            contact: checkUserFormData.contact,
          },
        );

        if (response.data.status === 200 && response.data.response.user.token !== '') {
          rootStore.userStore.setUser(response.data.response.user);
          const {
            token,
            contact,
            user_id,
            last_name,
            user_type,
            first_name,
            email_address,
          } = response.data.response.user;

          const Toast = Swal.mixin({
            toast: true,
            timer: 5000,
            position: 'top-end',
            timerProgressBar: true,
            showConfirmButton: false,
            didOpen: toast => {
              toast.addEventListener('mouseenter', Swal.stopTimer);
              toast.addEventListener('mouseleave', Swal.resumeTimer);
            },
          });

          if (user_type !== 'candidate') {
            Toast.fire({
              icon: 'error',
              title: t('jobseekerLogin.wrongCredentials'),
            });

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'website_error',
              'error_type': 'login error',
              'error_message': t('jobseekerLogin.wrongCredentials'),
            });

            setStep('checkUser');
            setCheckUserMessage('');
            setEmailConfirmCode('');
            setEmailConfirmCodeError('');
            setCheckUserFormData(prev => ({ ...prev, email_address: '' }));
          } else {
            await axios.post(BaseApi + '/setcontext', {
              user_id,
              user_type,
              lang: currentLanguage === 'ukr' ? 'uk' : currentLanguage,
            });

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'login',
              'user_id': user_id,
              'authentication_method': 'email',
            });

            Cookies.set('lname', last_name);
            Cookies.set('user_id', user_id);
            Cookies.set('fname', first_name);
            Cookies.set('tokenClient', token);
            Cookies.set('user_type', user_type);
            Cookies.set('contactNumber', contact);
            Cookies.set('emailAddress', email_address);

            Toast.fire({
              icon: 'success',
              title: t('jobseekerLogin.welcome')+', '+ first_name,
            });

               GoogleAnalyticsService.trackEvent(
        'jobseeker_registration',
         {"SUCCESS": t('jobseekerLogin.welcome')+', '+ first_name,});
            setStep('jobApplySelect');
          }
        } else {
          setEmailConfirmCodeError(response.data.message);
          
               GoogleAnalyticsService.trackEvent(
        'jobseeker_registration_respond',
         {"ERROR": response.data.message});
         
          }
        

        setIsSubmitting(false);
      }
    } catch (error) {
      setIsSubmitting(false);

      const Toast = Swal.mixin({
        toast: true,
        timer: 5000,
        position: 'top-end',
        timerProgressBar: true,
        showConfirmButton: false,
        didOpen: toast => {
          toast.addEventListener('mouseenter', Swal.stopTimer);
          toast.addEventListener('mouseleave', Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: 'error',
        title: t('jobDescription.checkCodeError'),
      });
         
        GoogleAnalyticsService.trackEvent(
        'jobseeker_registration_respond',
         {"ERROR": t('jobDescription.checkCodeError'),});
            setStep('jobApplySelect');
    }
  };

  const handleQuestionnaireSubmit = async e => {
    e.preventDefault();

    try {
      setIsSubmitting(true);

      const formData = new FormData();

      jobId && formData.append('idJob', jobId);
      subscribeAlert && formData.append('subscribeAlert', subscribeAlert);
      checkUserFormData.contact && formData.append('contact', checkUserFormData.contact);
      checkUserFormData.last_name && formData.append('last_name', checkUserFormData.last_name);
      checkUserFormData.first_name && formData.append('first_name', checkUserFormData.first_name);
      checkUserFormData.email_address && formData.append('email_address', checkUserFormData.email_address);

      const response = await axios.post(
        BaseApi + '/jobApply/sentJobApply',
        formData,
        {
          headers: {
            key: ApiKey,
            token: tokenKey,
          },
        },
      );

      if (response.data.status === 200) {
        setStep('jobApplyResult');
        setJobApplyResult(prev => ({
          ...prev,
          result: 'success',
          message: t('jobDescription.jobAppliedSuccess'),
        }));
      } else if (response.data.status === 500) {
        setStep('jobApplyResult');
        setJobApplyResult(prev => ({
          ...prev,
          result: 'warning',
          message: t('jobDescription.jobAlreadyApplied'),
        }));
      } else {
        setStep('jobApplyResult');
        setJobApplyResult(prev => ({
          ...prev,
          result: 'error',
          message: t('jobDescription.applyError'),
        }));
      }

      setIsSubmitting(false);
    }
    catch (error) {
      setIsSubmitting(false);

      const Toast = Swal.mixin({
        toast: true,
        timer: 5000,
        position: 'top-end',
        timerProgressBar: true,
        showConfirmButton: false,
        didOpen: toast => {
          toast.addEventListener('mouseenter', Swal.stopTimer);
          toast.addEventListener('mouseleave', Swal.resumeTimer);
        },
      });

      Toast.fire({
        icon: 'error',
        title: t('jobDescription.applyError'),
      });
    }
  };

  useEffect(() => {
    if (step === 'jobApplySelect') {
      getUserProfileData();
    }
  }
  , [step]); // eslint-disable-line

  const isPhoneConfirmed = checkUserFormData.contact && !checkUserFormData.email_address;

  const renderSubscribeAlert =()=> {
    if(!profileBody.email_address) {
      return null
    }
    if(profileBody.email_address?.includes('@email.grc.ua')){
      return null
    }
    return(<div className='subscribeAlertBox justify-content-center'>
                      <label className='subscribeAlertLabel '>
                        <input
                          type='checkbox'
                          name='subscribeAlert'
                          checked={subscribeAlert}
                          className='me-2 subscribeAlertCheckbox'
                          onChange={() => setSubscribeAlert(prevState => !prevState)}
                        />
                        {t('jobDescription.subscribeAlert')}
                      </label>
            </div>)
  }

  return (
    <Modal open={open} onClose={onClose}  aria-labelledby='apply-job-modal' aria-describedby='apply-job-modal-description'>
      <Box onClick={onClose} className='modal modal-content membershipModal jobDescriptionModal container'>
        <div
          style={{ width: '100%' }}
          onClick={e => e.stopPropagation()}
          className='modal-dialog membershipModal jobDescriptionModal container'
        >
          <div className='modal-content container'>
            <div className='modal-body px-0 jobApplyModal'>
              <IconButton
                onClick={onClose}
                className='close-button'
                style={{ top: 10, right: 10, position: 'absolute', color: '#000000', opacity: 0.5 }}
              >
                &times;
              </IconButton>
              {
                step === 'checkUser' && (
                  <div>
                    <div className='mx-auto enterInfoBox'>
                      <h2 className=''>{t('jobDescription.enterInfo')}</h2>
                      <h2 className='mb-4'>{t('jobDescription.enterInfo1.1')}</h2>
                      <ApplyJobInfoForm
                        errors={errors}
                        setErrors={setErrors}
                        onSubmit={handleCheckUser}
                        isSubmitting={isSubmitting}
                        formData={checkUserFormData}
                        setFormData={setCheckUserFormData}
                      />
                    </div>
                    <Link className='my-4 fs-6 d-block text-center' to='/user/register/employer'>{t('jobDescription.employerRegister')}</Link>
                  </div>
                )
              }
              {
                step === 'checkEmailCode' && (
                  <div className='mx-auto enterInfoBox'>
                    <h2 className='mb-4'>{
                          isPhoneConfirmed ? 'Підтвердіть телефон' : t('jobDescription.emailConfirm')}</h2>
                    <p className='mb-4 fs-6'>{checkUserMessage}</p>
                    <ApplyJobCheckEmailForm
                      phoneConfirmed={isPhoneConfirmed}
                      setStep={setStep}
                      isSubmitting={isSubmitting}
                      onSubmit={handleEmailConfirm}
                      emailConfirmCode={emailConfirmCode}
                      setEmailConfirmCode={setEmailConfirmCode}
                      emailConfirmCodeError={emailConfirmCodeError}
                      setEmailConfirmCodeError={setEmailConfirmCodeError}
                    />
                  </div>
                )
              }
              {
                step === 'jobApplySelect' && (
                  <div className='mx-auto enterInfoBox'>
                    <h2 className='mb-4'>
                      {t('jobDescription.jobApplyTitle')}:
                      <span className='d-block' style={{ color: '#294A9C' }}>&quot;{jobTitle}&quot;</span>
                    </h2>
                    <ApplyJobSelectForm
                      jobId={jobId}
                      setStep={setStep}
                      onlyResume={onlyResume}
                      isSubmitting={isSubmitting}
                      subscribeAlert={subscribeAlert}
                      setIsSubmitting={setIsSubmitting}
                      emailConfirmCode={emailConfirmCode}
                      checkUserFormData={checkUserFormData}
                      onlyQuestionnaire={onlyQuestionnaire}
                      setJobApplyResult={setJobApplyResult}
                      setSubscribeAlert={setSubscribeAlert}
                      setEmailConfirmCode={setEmailConfirmCode}
                      emailConfirmCodeError={emailConfirmCodeError}
                      setEmailConfirmCodeError={setEmailConfirmCodeError}
                    />
                  </div>
                )
              }
              {
                step === 'createResume' && (
                  <div className='mx-auto editProfile' style={{ maxWidth: '918px' }}>
                    <ApplyJobCreateResumeForm
                      step={step}
                      setStep={setStep}
                      faculties={faculties}
                      directories={directories}
                      profileBody={profileBody}
                      setFaculties={setFaculties}
                      subscribeAlert={renderSubscribeAlert()}
                    />
                  </div>
                )
              }
              {
                step === 'questionnaire' && (
                  <div className='mx-auto enterInfoBox'>
                    <h2 className='mb-4'>
                      {t('jobDescription.jobApplyTitle')}:
                      <span className='d-block' style={{ color: '#294A9C' }}>&quot;{jobTitle}&quot;</span>
                    </h2>
                    <div className='mb-4 questionnaireBox'>
                      <p className='fs-6 fw-bold'>{profileBody.first_name} {profileBody.last_name}</p>
                      <p className='fs-6 text-muted'>{
                        (function(){
                          if(profileBody.email_address) {
                             if(!profileBody.email_address?.includes('@email.grc.ua')) {
                                return profileBody.email_address;
                             }else {
                                return ''
                             }
                          }else {
                            return ''
                          }
                        })()}</p>
                      <p className='fs-6 text-muted'>{profileBody.contact_number}</p>
                      <Link onClick={() => setStep('editQuestionnaire')}>{t('jobDescription.editInfo')}</Link>
                    </div>

                    { /** Subscribe aler render */}
                    {renderSubscribeAlert()}
                    <div className='dataProcessingConsentBox'>
                      <p>
                        {t('jobDescription.bottomTxt1')}{' '}
                        <Link to='/data-processing-consent'>
                          {t('jobDescription.bottomTxt2')}
                        </Link>
                      </p>
                    </div>
                    <div className='d-flex justify-content-evenly'>
                      {
                        !onlyQuestionnaire || !!onlyResume && (
                          <button
                            type='button'
                            className='btn button2'
                            onClick={() => setStep('jobApplySelect')}
                          >
                            {t('jobDescription.backButton')}
                          </button>
                        )
                      }
                      <button
                        type='submit'
                        disabled={isSubmitting}
                        className='mt-0 btn button1'
                        onClick={handleQuestionnaireSubmit}
                      >
                        {t('jobDescription.applyNow')}{' '}
                        {isSubmitting && <SmallLoading width='24px' height='24px' color='#FFF' style={{ marginLeft: '8px' }} />}
                      </button>
                    </div>
                  </div>
                )
              }
              {
                step === 'editQuestionnaire' && (
                  <div>
                    <div className='mx-auto enterInfoBox'>
                      <h2 className='mb-4'>
                        {t('jobDescription.jobApplyTitle')}:
                        <span className='d-block' style={{ color: '#294A9C' }}>&quot;{jobTitle}&quot;</span>
                      </h2>
                      <ApplyJobInfoForm
                        editInfo
                        errors={errors}
                        setStep={setStep}
                        setErrors={setErrors}
                        isSubmitting={isSubmitting}
                        formData={checkUserFormData}
                        subscribeAlert={subscribeAlert}
                        setFormData={setCheckUserFormData}
                        onSubmit={handleQuestionnaireSubmit}
                        setSubscribeAlert={setSubscribeAlert}
                      />
                    </div>
                  </div>
                )
              }
              {
                step === 'jobApplyResult' && (
                  <div>
                    <div
                      className={
                        `jobApplyResultBox ${jobApplyResult.result === 'success' ? 'success' : jobApplyResult.result === 'error' ? 'error' : 'warning'}`
                      }
                    >
                      {
                        jobApplyResult.result === 'success' && (
                          <h2>
                            <CheckCircleIcon sx={{ mr: '8px', width: '40px', height: '40px', color: '#294A9C' }} />
                            {t('jobDescription.jobAppliedSuccess')}
                          </h2>
                        )
                      }
                      {
                        jobApplyResult.result === 'error' && (
                          <h2>
                            <ErrorIcon sx={{ mr: '8px', width: '40px', height: '40px', color: '#294A9C' }} />
                            {t('jobDescription.applyError')}
                          </h2>
                        )
                      }
                      {
                        jobApplyResult.result === 'warning' && (
                          <h2>
                            <CancelIcon sx={{ mr: '8px', width: '40px', height: '40px', color: '#294A9C' }} />
                            {t('jobDescription.jobAlreadyApplied')}
                          </h2>
                        )
                      }
                    </div>
                    <div className='d-flex justify-content-evenly'>
                      <button
                        type='submit'
                        onClick={onClose}
                        className='mt-0 mb-5 btn button1'
                      >
                        {t('jobDescription.viewOtherVacancies')}
                      </button>
                    </div>
                  </div>
                )
              }
            </div>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default ApplyJobModal;
